module.exports = __webpack_public_path__ + "img/CFC9-Logo2021.0defb344.jpg";